import { IChatbotDiscussion } from '@agent/core/channel-digit/chatbot/models/chatbot-discussion';
import { IHttpService, ILogService, IPromise, IQService } from 'angular';
import { Subscription } from 'rxjs';

import { Configuration } from '@contact/upgrade';

const MODULE_NAME = 'chatbotService';

export interface IChatbotService {
  getChatbotDiscussions(discussionUuid: string): IPromise<IChatbotDiscussion>;
}

export class ChatbotService implements IChatbotService {
  static $inject: Array<string> = ['$log', '$q', '$http', 'configuration'];
  public name = MODULE_NAME;
  private haveOpenSubscription: Subscription;
  private DISCUSSIONS_URL = '/discussion/';

  constructor(
    protected readonly $log: ILogService,
    private readonly $q: IQService,
    private readonly $http: IHttpService,
    private readonly configuration: Configuration
  ) {}

  getChatbotDiscussions(discussionUuid: string): IPromise<IChatbotDiscussion> {
    let deferred = this.$q.defer<any>();
    this.$http.get(this.getBaseUrl() + this.DISCUSSIONS_URL + discussionUuid + '/light').then(
      success => {
        if (success.data) {
          deferred.resolve(success.data);
        } else {
          deferred.reject();
        }
      },
      () => {
        deferred.reject();
      }
    );

    return deferred.promise;
  }

  getBaseUrl(): string {
    return this.configuration.masterbotBaseUrl + '/api';
  }

  $onDestroy() {
    this.haveOpenSubscription.unsubscribe();
  }
}

export default MODULE_NAME;
